import React from 'react';
import axios from 'axios'
import Loading from './loading'
import Alterfailure from './alter_failure';

class AvailablePolls extends React.Component {
    state = {
        votedpreviously: false
    }

    componentDidMount() {
        axios.get('/api/student')
            .then((response) => {
                // console.log(response.data)
                this.props.changeData(response.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }

    alreadyVoted = () => {
        this.setState({
            votedpreviously: "You have already voted in this poll"
        })
        setTimeout(() => {
            this.setState({
                votedpreviously: false
            })
        }, 3500)
    }

    checkIfVoted = (id) => {
        if (this.props.user_data.voted[0] === id) {
            return true
        } else {
            return false
        }

    }

    calculateTimeSince = (date) => {
        var seconds = Math.floor((new Date() - date) / 1000);
        var interval = Math.floor(seconds / 31536000);

        if (interval > 0) {
            if (interval > 1) {
                return interval + " years";
            } else {
                return interval + " year";
            }
        }
        interval = Math.floor(seconds / 2592000);
        if (interval > 0) {
            if (interval > 1) {
                return interval + " months";
            } else {
                return interval + " month";
            }
        }
        interval = Math.floor(seconds / 86400);
        if (interval > 0) {
            if (interval > 1) {
                return interval + " days";
            } else {
                return interval + " day";
            }
        }
        interval = Math.floor(seconds / 3600);
        if (interval > 0) {
            if (interval > 1) {
                return interval + " hours";
            } else {
                return interval + " hour";
            }
        }
        interval = Math.floor(seconds / 60);
        if (interval > 0) {
            if (interval > 1) {
                return interval + " minutes";
            } else {
                return interval + " minute";
            }
        }
        return Math.floor(seconds) + " seconds";
    }
    render() {
        if (this.props.data[0]) {
            return (
                <>
                    {this.state.votedpreviously ? <Alterfailure errmsg={this.state.votedpreviously} /> : null}
                    <div style={{ marginTop: "30px" }}>
                        {this.props.data.map((arr) => (
                            <div class="card text-center col-sm-7 available">
                                <div class="card-header">
                                    Active poll
                </div>
                                <div class="card-body">
                                    <h5 class="card-title">{arr.pollName || 'New Poll'}</h5>
                                    <p class="card-text">{arr.description || 'Click below to participate in the poll'}</p>
                                    <p class={this.checkIfVoted(arr._id) ? "btn btn-secondary vote-btn" : "btn btn-primary vote-btn"}
                                        onClick={this.checkIfVoted(arr._id) ? () => this.alreadyVoted() : () => this.props.setPoll(arr._id)}>Vote</p>
                                </div>
                                <div class="card-footer text-muted">
                                    {this.calculateTimeSince(new Date(this.props.data[0].createdAt))}
                                </div>
                            </div>
                        ))}
                    </div>

                </>
            )
        } else {
            return (
                <Loading />
            )
        }
    }
}

export default AvailablePolls;